import { render, staticRenderFns } from "./ContentLabels.vue?vue&type=template&id=cafec72a&"
import script from "./ContentLabels.vue?vue&type=script&lang=js&"
export * from "./ContentLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports